export type { IconType } from "./Icon";
export { default } from "./Icon";
